import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { IInspectionListItem, InspectionService, APP_CONFIG, IAppConfig, InputConverterService } from 'ee-common-lib';
import { Subscription } from 'rxjs';
import {IInspectionRequestedEvent, IInspectionRequestFailedEvent} from '../request-inspection-button/request-inspection-button.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-recent-inspections',
	templateUrl: './recent-inspections.component.html',
	styleUrls: ['./recent-inspections.component.scss']
})
export class RecentInspectionsComponent implements OnInit, OnDestroy {
	public loading: boolean;
	public inspections: IInspectionListItem[];
	public page: number;
	public pageCount: number;
	public totalInspectionCount: number;
	public pageSize: number;

	public errorMsg: string;
	public successMsg: string;

	private _inspectionsSub: Subscription;
	private _queryParamsSub: Subscription;

	constructor(
		private _inspectionService: InspectionService,
		private _route: ActivatedRoute,
		private _router: Router,
		@Inject(APP_CONFIG) private _appConfig: IAppConfig) {
		this.pageSize = this._appConfig.pageSize;
	}

	ngOnInit() {
		this._queryParamsSub = this._route.queryParamMap.subscribe(queryParams => {
			let page = 1;
			if (queryParams.has('page')) {
				page = InputConverterService.parseInt(queryParams.get('page'));
			}

			if (this.page !== page) {
				this.page = page;
				this.refreshInspections();
			}
		});

		this.refreshInspections();
	}

	ngOnDestroy() {
		this._queryParamsSub.unsubscribe();

		this.unsubscribeInspections();
	}

	public onPageChanged(page: number): void {
		this.page = page;
		this._router.navigate([], {
			relativeTo: this._route,
			queryParams: { page},
			queryParamsHandling: 'merge'
		});

		this.refreshInspections();
	}

	public refreshInspections(): void {
		this.unsubscribeInspections();

		this.loading = true;
		this.inspections = null;
		this._inspectionsSub = this._inspectionService.getRecentInspectionsList(this.page, this.pageSize).subscribe({
			next: inspectionPage => {
				this.inspections = inspectionPage.Items;
				this.pageCount = inspectionPage.PageCount;
				this.pageSize = inspectionPage.PageSize;
				this.totalInspectionCount = inspectionPage.TotalItemCount;
				this.loading = false;
			},
			error: () => {
				this.inspections = [];
				this.loading = false;
			}
		});
	}

	private getMonthText(numMonths: number) {
		return `${numMonths} ${numMonths === 1 ? 'month' : 'months'}`;
	}

	public onInspectionRequested(event: IInspectionRequestedEvent) {
		if (event.followUpRequested) {
			const monthText = this.getMonthText(event.numMonthsFromLastInspection);
			this.successMsg = `Follow-up requested ${monthText} from the last inspection for ${event.wellName}.`;
		} else {
			this.successMsg = `No follow-up requested for ${event.wellName}`;
		}

		this.refreshInspections();
	}

	public onInspectionRequestFailed(event: IInspectionRequestFailedEvent) {
		this.errorMsg = `Request failed for ${event.wellName}: ${event.error.Message}`;
	}

	public clearErrorMsg(): void {
		this.errorMsg = null;
	}

	public clearSuccessMsg(): void {
		this.successMsg = null;
	}

	private unsubscribeInspections() {
		if (this._inspectionsSub != null) {
			this._inspectionsSub.unsubscribe();
			this._inspectionsSub = null;
		}
	}
}
